module.exports = __webpack_public_path__ + "static/media/MosesPart1.83573028.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/Moses/MosesPart1.mp3
// module id = 149
// module chunks = 0